import './index.less';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import Timeline from '../components/Timeline/Timeline';
import MajorProjectTimeline from '../components/Timeline/MajorProjectTimeline';
import FacilityLoanTimeline from '../components/Timeline/FacilityLoanTimeline';
import CreditGuaranteeTimeline from '../components/Timeline/CreditGuaranteeTimeline';
import IndustryBankLoanTimeline from '../components/Timeline/IndustryBankLoanTimeline';
import AgriculturalSubsidiesTimeline from '../components/Timeline/AgriculturalSubsidiesTimeline';
import LargeGrainGrowerTimeline from '../components/Timeline/LargeGrainGrowerTimeline';
import TransformationProjectTimeline from '../components/Timeline/TransformationProjectTimeline';
// import ProjectSchedulingTimeline from '../components/Timeline/ProjectSchedulingTimeline';
import SupplyChainFinanceTimeline from '../components/Timeline/SupplyChainFinanceTimeline';
import SupplyChainInsuranceTimeline from '../components/Timeline/SupplyChainInsuranceTimeline';

const otherType = ['1', '2', '3', '4'];

export default function Detail() {
  const { search } = useLocation();
  return (
    <div className="myapplication-detail">
      <div className="content-width">
        {
          qs.parse(search).type === '5' && <MajorProjectTimeline />
        }
        {
          qs.parse(search).type === '6' && <FacilityLoanTimeline />
        }
        {
          qs.parse(search).type === '7' && <CreditGuaranteeTimeline />
        }
        {
          qs.parse(search).type === '8' && <IndustryBankLoanTimeline />
        }
        {
          qs.parse(search).type === '9' && <AgriculturalSubsidiesTimeline />
        }
        {
          qs.parse(search).type === '10' && <LargeGrainGrowerTimeline />
        }
        {
          qs.parse(search).type === '11' && <TransformationProjectTimeline />
        }
        {
          qs.parse(search).type === '12' && <SupplyChainFinanceTimeline />
        }
        {
          qs.parse(search).type === '13' && <SupplyChainInsuranceTimeline />
        }
        {/* {
          qs.parse(search).type === '13' && <ProjectSchedulingTimeline />
        } */}
        {
          otherType.includes(qs.parse(search).type) && <Timeline />
        }
      </div>
    </div>
  );
}
